import { TextField, ThemeProvider, createMuiTheme } from "@material-ui/core";
import React from "react";

const theme = createMuiTheme({
  typography: {
    fontFamily: "Nunito Sans, sans-serif",
  },
});

export default ({
  field,
  form,
  inputProps,
  error,
  isRequired,
  variant,
  ...props
}) => {
  return (
    <ThemeProvider theme={theme}>
      <TextField
        {...field}
        {...props}
        fullWidth
        required={isRequired}
        variant={variant || "outlined"}
        error={error}
        autoComplete="off"
        autoFocus={field.name === "email"}
        InputProps={{ ...inputProps }}
      />
    </ThemeProvider>
  );
};
